<template>
  <div>
    <!-- {{ info }} -->
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  computed: {
    ...mapState('malls', ['malls']),
  },
  created() {
    this.getMalls()
  },
  methods: {
    ...mapActions('mall', ['getMalls']),
  },
}
</script>
